<template>
  <div id="content" class="text-left">
    <h1>Premier diagnostic à remplir avec les données de la dernière semaine</h1>
    <v-form ref="form" v-model="formIsValid" id="diagnostic-form" @submit.prevent class="mb-4">
      <v-row class="mt-2">
        <v-col cols="12">
          <h2 class="mb-2 text-left">PESÉES déchets de préparation</h2>
          <DsfrTextField
            v-model.number="diagnostic.numberOfServedConsumers"
            label="Nombre de convives effectifs servis"
            class="text-left"
            required
          />
        </v-col>
        <v-col cols="12">
          <h2 class="mb-2 text-left">Quantités de nourritures préparées (chaud) en kg</h2>
          <DsfrTextField
            v-model.number="diagnostic.preparedFoodKG"
            label="Quantités de nourritures préparées"
            append-icon="mdi-weight"
            class="text-left"
          />
        </v-col>

        <v-col cols="12">
          <h2 class="mb-2 text-left">Déchets de préparation en kg</h2>
          <DsfrTextField
            v-model.number="diagnostic.preparedEdibleFoodKG"
            label="Déchets alimentaires COMESTIBLES en kg"
            append-icon="mdi-weight"
            class="text-left"
            required
          />
          <DsfrTextField
            v-model.number="diagnostic.preparedNonEdibleFoodKG"
            label="Déchets alimentaires/organiques NON COMESTIBLES en kg"
            append-icon="mdi-weight"
            class="text-left"
            required
          />
        </v-col>

        <v-col cols="12">
          <h2 class="mb-2 text-left">MENU</h2>
          <DsfrTextField v-model.number="diagnostic.menu" label="Préciser le menu" class="text-left" required />
        </v-col>

        <v-col cols="12">
          <h2 class="mb-2 text-left">Vérification</h2>
          <DsfrTextField
            v-model.number="diagnostic.verify"
            label="Préciser qui est en charge de la pesée (s'assurer de la véracité des mesures)"
            class="text-left"
            required
          />
        </v-col>
      </v-row>

      <v-row>
        <v-btn large color="primary" @click="submitForm" :disabled="!formIsValid" class="my-8">
          Soummettre
        </v-btn>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import validators from "@/validators"
import DsfrTextField from "@/components/DsfrTextField"

export default {
  name: "FirstDiagnosticPage",
  components: {
    DsfrTextField,
  },
  data() {
    return {
      diagnostic: {
        numberOfServedConsumers: null,
        preparedFoodKG: null,
        preparedEdibleFoodKG: null,
        preparedNonEdibleFoodKG: null,
        menu: null,
        verify: null,
      },
    }
  },
  methods: {
    submitForm() {
      console.log("formulaire evoyé: ", this.diagnostic)
      this.$router.push("/resume-diagnostic-gaspillage")
    },
  },
  computed: {
    validators() {
      return validators
    },
    formIsValid() {
      return Object.values(this.diagnostic).every((value) => value !== "" && value !== null && value !== undefined)
    },
  },
}
</script>

<style scoped>
#content {
  width: 210mm;
}

#diagnostic-form {
  display: flex;
  flex-direction: column;
  align-items: left;
  max-width: 1500px !important;
  margin: auto;
}

::v-deep span.fr-hint-text {
  display: none !important;
}

h2 {
  font-size: 1.2rem;
  font-weight: bold;
  margin-bottom: 0.5rem;
}

.text-left {
  text-align: left;
}

@media (max-width: 210mm) {
  #content {
    width: 100%;
  }
}
</style>
